import { isSocketDebugNotificationsActivated } from '@functions/functions';
import { EToastVariant } from '@notifications/components/Toast/Toast.enum';
import useAddToast from '@store/toastsStore/hooks/useAddToast';
import { useCallback, useEffect } from 'react';
import { SUCCESS } from 'src/texts/feedbackMessages';
import { EDiscordEvent, ETopic } from '../socketStore.enum';
import { ISocketMessage } from '../socketStore.type';
import { useSocket } from './useSocket';

export const useDiscordSocketEvents = () => {
	const [socket] = useSocket();

	const { addToast } = useAddToast();

	const handleMessage = useCallback(
		(message: ISocketMessage<ETopic.discord, EDiscordEvent>) => {
			if (message.topic !== ETopic.discord) return;

			try {
				switch (message.event) {
					case EDiscordEvent.permissionsAdded:
						console.log('Permissions added');

						if (isSocketDebugNotificationsActivated()) {
							const typedMessage = message as ISocketMessage<ETopic.discord, EDiscordEvent.permissionsAdded>;

							addToast({
								uuid: message.notificationId,
								title: SUCCESS.discord.newRole.title + ' ' + typedMessage.data.role,
								message: SUCCESS.discord.newRole.message,
								variant: EToastVariant.information
							});
						}
						break;
					case EDiscordEvent.permissionsRemoved:
						console.log('Permissions removed');

						if (isSocketDebugNotificationsActivated()) {
							const typedMessage = message as ISocketMessage<ETopic.discord, EDiscordEvent.permissionsRemoved>;

							addToast({
								uuid: message.notificationId,
								title: SUCCESS.discord.roleRemoved.title + ' ' + typedMessage.data.role,
								message: SUCCESS.discord.roleRemoved.message,
								variant: EToastVariant.information
							});
						}
						break;
					case EDiscordEvent.usernameUpdated:
						console.log('Username updated');

						if (isSocketDebugNotificationsActivated()) {
							const typedMessage = message as ISocketMessage<ETopic.discord, EDiscordEvent.usernameUpdated>;

							addToast({
								uuid: message.notificationId,
								title: SUCCESS.generic,
								message: SUCCESS.discord.usernameUpdated(typedMessage.data.discordUsername),
								variant: EToastVariant.success
							});
						}
						break;
					default:
						break;
				}
			} catch (err) {
				console.error('useDiscordSocketEvents', err);
			}
		},
		[addToast]
	);

	useEffect(() => {
		if (socket) {
			socket.connect();

			// fired when socket is successfully connected
			socket.on('connect', () => {
				console.debug(ETopic.discord, 'socket connected');
			});

			socket.on(ETopic.discord, handleMessage);

			return () => {
				socket.off('connect');
				socket.off(ETopic.discord, handleMessage);
				socket.close();
			};
		}
	}, [handleMessage, socket]);
};
